<template>
  <scroll-bar>
    <div class="logoWrapper">
      <img width="100%" src="../../../../assets/images/logo@2x.png" alt="">
      <!-- 这里想通过设置常量调用，这样可以统一修改，但是一直都不成功 -->
      <!-- <img width="52" height="25" :src="require(logo_src)" alt=""> -->
      <!-- <img width="52" height="25" :slogorc="$enum.LOGO_SRC" alt=""> -->
      <!-- <div class="logoTitle">{{$t('login.nibd')}}</div> -->
    </div>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      text-color="#FFFFFF"
      style="background-color: none;"
      class="menu"
      active-text-color="#CB372B"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  // data() {
  //     return {
  //       logo_src: '@/assets/images/logo.png',
  //     };
  // },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      let routers = this.routers
      routers.forEach((items)=>{
        if (items.children&&items.children.length>0) {
          items.children.forEach((item)=>{
            let name = item.name
            item.meta.lang=this.$t(`routers.${name}`)
          })
        }

      })
      return routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .logoWrapper{
     text-align: center;
    .logoTitle{
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 50px;
      text-align: center;
    }
  }
.el-menu {
  background-color: transparent;
}

.el-menu-item {
  background-color: rgba(0, 0, 0, 0.1);
}
.menu >>> .el-menu-item:focus, .el-menu-item:hover {
  color: red !important;
}
.menu >>> .el-menu-item:hover {
  color: red !important;
}
.menu >>> .el-submenu__title:hover {
  color: red !important;
}
.menu >>> .el-menu-item.is-active {
  background-color: #FFFFFF !important;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue